import {Component, Input, OnInit} from '@angular/core';
import {Scenario} from '../../state/AppState';


@Component({
  selector: 'mortgagesummary-tag',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  title = 'the-summary';
  remainingDebt = '';
  interestPayed = '';
  premiumPayed = '';
  principalPayed = '';
  _scenario: Scenario;
  _useInflationCorrection: boolean;

  @Input()
  set scenario(scenario: Scenario) {
    this._scenario = scenario;
    this.update();
  }

  @Input()
  set useInflationCorrection(value: boolean) {
    this._useInflationCorrection = value;

    this.update();
  }

  constructor() {
    console.log('init summary');
  }

  ngOnInit(): void {
    console.log('Init Mortgage summary');
  }

  update(): void {
    let remainingDebt = 0;
    let interestPayed = 0;
    let premiumPayed = 0;
    let principalPayed = 0;

    const inflationRate = this._scenario.inflationRate/100;
    const inverseInflationRate = 1. / (1 + inflationRate) - 1;
    const monthlyInflationCorrection = Math.pow(1 + inverseInflationRate, 1 / 12);

    for (const i in this._scenario.mortgages) {

      const data = this._scenario.mortgages[i];
      const timeline = data.timeline;

      if (timeline.length > 0) {
        const lastMonth = timeline[timeline.length - 1];

        remainingDebt += lastMonth.currentRemainder;
        interestPayed += lastMonth.currentTotalInterestPayment;
        premiumPayed += lastMonth.currentTotalPremiumPayment;
        principalPayed += lastMonth.currentTotalPrincipalPayment;
      } else {
        console.log('no data');
      }
    }

    if (this._useInflationCorrection) {
      let maxLength = 0;
      for (const i in this._scenario.mortgages) {
        const months = this._scenario.mortgages[i].timeline.length;
        if (months > maxLength) {
          maxLength = months;
        }
      }

      let currentCorrection = 1.;
      for (let i = 0; i < (maxLength - 1); i++) {
        currentCorrection = currentCorrection * monthlyInflationCorrection;
      }

      remainingDebt = remainingDebt * currentCorrection;
      interestPayed = interestPayed * currentCorrection;
      premiumPayed = premiumPayed * currentCorrection;
      principalPayed = principalPayed * currentCorrection;
    }

    this.remainingDebt = remainingDebt.toFixed(2);
    this.interestPayed = interestPayed.toFixed(2);
    this.premiumPayed = premiumPayed.toFixed(2);
    this.principalPayed = principalPayed.toFixed(2);
  }


}
